import React from 'react';
import { FormattedMessage } from 'react-intl';

const _t = (_id, _default_msg) => (
  <FormattedMessage id={_id} defaultMessage={_default_msg} />
);
export default _t;
